import type { StudentLectureDtoT } from '@mathflat/domain/@entities/StudentLecture'
import { useInfiniteQuery } from '@tanstack/react-query'

import { studentLectureApi } from '~/@common/api/studentLectureApi'

const DEFAULT_PAGE_SIZE = 30

export const useStudentLectureAssignments = (
  params: Omit<StudentLectureDtoT.GetStudentLectureAssignmentsRequest, 'page' | 'size'>,
) => {
  return useInfiniteQuery({
    queryKey: ['student-lecture', 'assignments', params] as const,
    queryFn: ({ pageParam }) =>
      studentLectureApi.getAssignments({ ...params, page: pageParam, size: DEFAULT_PAGE_SIZE }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => (!lastPage.last ? allPages.length : undefined),
  })
}
